// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1eaQZ","imageUploader":"EGiftCard_imageUploader__1vaG0"};